var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"nobody":""}},[_c('JobMetrics',{staticClass:"job-metrics",attrs:{"job-id":_vm.args.job_id,"should-show-aws-estimate":false,"should-show-carbon-emission-estimates":false,"include-title":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }